import { Component, Input } from '@angular/core';
import {
  ACTIVITY_ICON_LABEL,
  ActivityIconKind,
} from 'src/app/shared/utils/impact-panel.utils';

@Component({
  selector: 'app-activity-event-icon',
  templateUrl: './activity-event-icon.component.html',
  styleUrls: ['./activity-event-icon.component.scss'],
})
export class ActivityEventIconComponent {
  @Input() iconKind: ActivityIconKind = 'default';
  @Input() tone = 'info';
  @Input() label?: string;

  get tooltip(): string {
    return this.label || ACTIVITY_ICON_LABEL[this.iconKind] || ACTIVITY_ICON_LABEL.default;
  }
}
